module.exports = __webpack_public_path__ + "img/profile_yellow.ce6adf2e.svg";